import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'common-ui-switch',
  templateUrl: './switch.component.html',
  styleUrls: ['./switch.component.scss']
})
export class SwitchComponent {

  @Input()
  public checked: boolean;

  @Output()
  public checkedChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input()
  public id: string;

  @Input()
  public readonly;

  public onToggle(): void {
    this.checkedChange.emit(this.checked);
  }
}
